var FreeShippingView = (function (GlobalSettings) {
    return Backbone.View.extend({
        el: '@freeShippingContainer',
        initialize: function () {
            _.bindAll(this, 'render');
            this.listenTo(this.model.get('Summary'), 'change', this.render);
        },
        render: function () {
            var amountToFreeDelivery = this.model.get('Summary').get('AmountToFreeDelivery');
            var delivery = this.model.get('Summary').get('Delivery');
            var hasNoShipments = this.model.get('ShipmentsList').length === 0;

            var html = '';
            if (delivery > 0 && amountToFreeDelivery > 0 && hasNoShipments) {
                html = $.tmpl('bt-checkout-free-shipping',
                    {
                        Value: window.toMoney(amountToFreeDelivery, GlobalSettings.CurrencySign)
                    }
                );
            }

            this.$el.html(html);

            return this;
        }
    });
})(GlobalSettings);